export default "__VITE_ASSET__BSyoNoqc__"